import { CableSetup, Charger, ProductUrls } from "_core/types";
import { pagesList } from "_core/config/pagesList";
import {
  AndersenCableLength,
  BaseColour,
  HypervoltCableLength,
} from "_core/types/charger";
import {
  PRICE_HYPERVOLT_10M,
  PRICE_HYPERVOLT_5M,
  PRICE_HYPERVOLT_7_5M,
  PRICE_INDRA_TETHERED,
  PRICE_INDRA_UNTETHERED,
} from "_core/config/prices";

const chargersWithCustomisation = (): Charger[] => {
  return [
    Charger.INDRA,
    Charger.HYPERVOLT,
    Charger.ANDERSENA2,
    Charger.ANDERSENA3,
    Charger.ANDERSENQUARTZ,
    Charger.ZAPPI21,
  ];
};

export const pagesForCharger = (charger: Charger | null): ProductUrls[] => {
  const excludeProductUrls: ProductUrls[] = [];
  if (charger === null || !chargersWithCustomisation().includes(charger)) {
    excludeProductUrls.push(ProductUrls.ChargerCustomisation);
  }
  return pagesList.filter(
    (productUrl) => !excludeProductUrls.includes(productUrl)
  );
};

export const customizationPageForCharger = (
  charger: Charger | null
): ProductUrls | null => {
  if (charger && chargersWithCustomisation().includes(charger)) {
    return ProductUrls.ChargerCustomisation;
  }
  return null;
};

export const getPrice = (
  charger: Charger | null,
  cableSetup: CableSetup | undefined,
  cableLength: AndersenCableLength | HypervoltCableLength | undefined,
  baseColour: BaseColour | undefined
) => {
  if (charger) {
    if (charger === Charger.HYPERVOLT) {
      return cableLength === "5m"
        ? PRICE_HYPERVOLT_5M
        : cableLength === "7.5m"
        ? PRICE_HYPERVOLT_7_5M
        : PRICE_HYPERVOLT_10M;
    } else if (charger === Charger.INDRA) {
      return cableSetup === "tethered"
        ? PRICE_INDRA_TETHERED
        : PRICE_INDRA_UNTETHERED;
    } else if (charger === Charger.ANDERSENQUARTZ) {
      if (cableSetup === "tethered") {
        switch (cableLength) {
          case "5.5m":
            return baseColour === "CotswoldOak_Cashmere" ? 1399 : 1249;
          case "8.5m":
            return baseColour === "CotswoldOak_Cashmere" ? 1449 : 1299;
          default:
            return 0;
        }
      } else return baseColour === "CotswoldOak_Cashmere" ? 1349 : 1199;
    } else if (charger === Charger.ANDERSENA3) {
      return baseColour === "CotswoldOak_CornishCream" ? 1699 : 1499;
    } else if (charger === Charger.ANDERSENA2) {
      return baseColour === "CotswoldOak_CornishCream" ? 1999 : 1799;
    } else {
      return 0;
    }
  }
};
